import { PersonaType } from '@/modules/auth/domain/models/Persona'

import { axios, Response } from '../index'

export interface GroupUsersByFeedGroup {
  id: number
  name: string
  personaType: PersonaType
}

const listGroupUsersByFeedGroups = (
  groupId: string
): Response<GroupUsersByFeedGroup[]> => {
  return axios.get(`/v1/group/${groupId}/profiles`)
}

export default listGroupUsersByFeedGroups
